(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-collector"]) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('.kc-lightbox');
    let returnFocus;
    if (dialog && typeof dialog.showModal === 'function') {
      root.querySelectorAll('.kc-media figure img').forEach(img => {
        if (img.closest('a,button')) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', root.dataset.zoomLabel + ' : ' + img.alt);
        img.before(button); button.append(img);
        button.addEventListener('click', () => {
          returnFocus = button;
          const enlarged = dialog.querySelector('img');
          enlarged.src = img.currentSrc || img.src;
          enlarged.alt = img.alt;
          dialog.querySelector('p').textContent = img.closest('figure').querySelector('figcaption')?.textContent || img.alt;
          dialog.showModal();
        });
      });
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => {
        if (e.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => returnFocus?.focus({preventScroll:true}));
    }
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('kc-enter'); observer.unobserve(entry.target);
      }), {threshold:0.07});
      root.querySelectorAll('[data-kc-reveal]').forEach(el => observer.observe(el));
    }
  };
  document.querySelectorAll('[data-collector-article]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-collector-article]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
